import { z } from 'zod';
import { ACCOUNTING_TAGS, EVENT_TYPES } from '../accounting/categories.js';
import { DecimalStringSchema } from './primitives.js';

export const EventTypeSchema = z.enum(EVENT_TYPES);

export const ClassifiedEventInputSchema = z.object({
  eventType: EventTypeSchema,
  tag: z
    .enum(ACCOUNTING_TAGS)
    .default('DEFAULT')
    .refine((tag) => tag !== 'STAKING_DELEGATE' && tag !== 'STAKING_UNDELEGATE', {
      message:
        'Le staking de principal n’est pas pris en charge par le moteur comptable ; à qualifier avec l’expert-comptable.',
    }),
  swapGroupId: z.string().max(120).nullable().default(null),
  assetId: z.number().int().positive(),
  amount: DecimalStringSchema,
  direction: z.union([z.literal(1), z.literal(-1)]),
  counterparty: z.string().max(120).nullable().default(null),
  counterpartyLabel: z.string().max(120).nullable().default(null),
  notes: z.string().max(500).nullable().default(null),
  occurredAt: z.number().int().nonnegative(),
  logIndexRef: z.number().int(),
});

export const ClassificationOverridePayloadSchema = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('IGNORE'),
    reason: z
      .string()
      .min(10)
      .max(500)
      .refine((reason) => reason === reason.trim()),
  }),
  z.object({
    type: z.literal('OVERRIDE'),
    events: z.array(ClassifiedEventInputSchema).min(1).max(50),
  }),
]);

export type ClassificationOverridePayload = z.infer<typeof ClassificationOverridePayloadSchema>;
